// extracted by mini-css-extract-plugin
export default {"tooltip":"OccupancyRateLineChart_tooltip__gpxFx","leftTooltip":"OccupancyRateLineChart_leftTooltip__xEvLO","rightTooltip":"OccupancyRateLineChart_rightTooltip__cx1Ei"};